/* =============================================================
   JDS Cart Upsells (global)
   Shipping Protection (opt-out toggle), Fast-Track (opt-in radio),
   Cart-Recs quick-add. Loaded on every page via layout/theme.liquid so it
   runs regardless of how Horizon renders the cart drawer.
   - Dispatches cart:update in the shape Horizon requires (detail.data must
     exist) so the drawer re-renders + cart bubble updates.
   - Shipping Protection toggle reflects the ACTUAL cart contents (source of
     truth), so it can never invert/desync; localStorage only remembers the
     opt-out choice for auto-add on future items.
   - MutationObserver re-applies widget state after each cart re-render.
   Config (variant ids) comes from window.JDS_UPSELLS (jds-upsell-config.liquid).
   ============================================================= */
(function () {
  'use strict';

  var CFG = window.JDS_UPSELLS || {};
  var SP = CFG.shippingProtection || {};
  var FT = CFG.fastTrack || {};
  var SP_VID = (SP.variantId || '').toString().trim();
  var FT_RUSH = (FT.rushVariantId || '').toString().trim();
  var FT_EXP = (FT.expressVariantId || '').toString().trim();
  var UPSELL_VIDS = [SP_VID, FT_RUSH, FT_EXP].filter(Boolean);
  var resyncTimer;
  var lastCart = null;

  /* ---------- cart helpers ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }
  function addVariant(vid) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function (r) { return r.json(); });
  }
  function removeKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }
  function findLine(cart, vid) {
    return (cart && cart.items || []).filter(function (i) { return String(i.variant_id) === vid; })[0];
  }
  function hasRealItems(cart) {
    return (cart && cart.items || []).some(function (i) { return UPSELL_VIDS.indexOf(String(i.variant_id)) === -1; });
  }
  /* Dispatch cart:update with a proper detail object so Horizon re-renders. */
  function refreshCart() {
    return getCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'jds-upsells', data: { source: 'jds-upsells', itemCount: cart.item_count } }
      }));
      return cart;
    }).catch(function () {});
  }

  /* ---------- Shipping Protection (opt-out) ---------- */
  var SP_KEY = 'jds_sp_on';
  function spOn() { try { return localStorage.getItem(SP_KEY) !== '0'; } catch (e) { return true; } }
  function spSet(on) { try { localStorage.setItem(SP_KEY, on ? '1' : '0'); } catch (e) {} }
  function spInCart() { return !!(lastCart && findLine(lastCart, SP_VID)); }
  /* Toggle reflects ACTUAL cart contents (falls back to pref before first load). */
  function spSyncUI() {
    var btn = document.getElementById('jds-ship-protect-btn');
    if (!btn) return;
    var on = lastCart ? spInCart() : spOn();
    if (btn.getAttribute('aria-checked') !== String(on)) btn.setAttribute('aria-checked', String(on));
  }
  /* Auto-add SP iff (pref on AND cart has >=1 real item). Avoids phantom carts. */
  function spReconcile(cart) {
    if (!SP.enabled || !SP_VID) return Promise.resolve(false);
    var run = cart ? Promise.resolve(cart) : getCart();
    return run.then(function (c) {
      var line = findLine(c, SP_VID);
      var want = spOn() && hasRealItems(c);
      if (want && !line) return addVariant(SP_VID).then(function () { return true; });
      if (!want && line) return removeKey(line.key).then(function () { return true; });
      return false;
    }).catch(function () { return false; });
  }

  /* ---------- Fast-Track (opt-in radio) ---------- */
  var FT_KEY = 'jds_ft';
  function ftPref() { try { return localStorage.getItem(FT_KEY) || ''; } catch (e) { return ''; } }
  function ftSet(v) { try { localStorage.setItem(FT_KEY, v || ''); } catch (e) {} }
  function ftVid(tier) { return tier === 'rush' ? FT_RUSH : tier === 'express' ? FT_EXP : ''; }
  function ftSyncUI() {
    var pref = ftPref();
    var opts = document.querySelectorAll('.jds-fast-track__opt');
    for (var i = 0; i < opts.length; i++) {
      var want = String(opts[i].dataset.tier === pref);
      if (opts[i].getAttribute('aria-checked') !== want) opts[i].setAttribute('aria-checked', want);
    }
  }
  function ftReconcile(target, cart) {
    if (!FT.enabled) return Promise.resolve(false);
    var all = [FT_RUSH, FT_EXP].filter(Boolean);
    var desired = ftVid(target);
    var run = cart ? Promise.resolve(cart) : getCart();
    return run.then(function (c) {
      var items = c.items || [];
      var ops = [];
      items.forEach(function (it) {
        var v = String(it.variant_id);
        if (all.indexOf(v) !== -1 && v !== desired) ops.push(function () { return removeKey(it.key); });
      });
      var hasDesired = desired && items.some(function (it) { return String(it.variant_id) === desired; });
      if (desired && !hasDesired) ops.push(function () { return addVariant(desired); });
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve()).then(function () { return ops.length > 0; });
    }).catch(function () { return false; });
  }

  /* ---------- shared UI sync ---------- */
  function syncAll() { spSyncUI(); ftSyncUI(); }
  function scheduleResync() { clearTimeout(resyncTimer); resyncTimer = setTimeout(syncAll, 40); }

  /* ---------- init (once) ---------- */
  function init() {
    if (window.__jdsUpsellsInit) return;
    window.__jdsUpsellsInit = true;

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var sp = e.target.closest('.jds-ship-protect__toggle');
      if (sp) {
        var vid = (sp.dataset.variantId || SP_VID || '').trim();
        if (!vid) return;
        var turnOn = sp.getAttribute('aria-checked') !== 'true';
        sp.setAttribute('aria-checked', String(turnOn)); /* optimistic */
        spSet(turnOn);
        sp.disabled = true;
        getCart().then(function (cart) {
          var line = findLine(cart, vid);
          if (turnOn && !line) return addVariant(vid);
          if (!turnOn && line) return removeKey(line.key);
          return null;
        }).then(function () { return refreshCart(); })
          .catch(function () {})
          .finally(function () { sp.disabled = false; syncAll(); });
        return;
      }

      var ft = e.target.closest('.jds-fast-track__opt');
      if (ft) {
        var tier = ft.dataset.tier;
        var next = (ftPref() === tier) ? '' : tier;
        ftSet(next); ftSyncUI();
        var group = ft.closest('.jds-fast-track');
        if (group) group.style.pointerEvents = 'none';
        ftReconcile(next).then(function (changed) { if (changed) return refreshCart(); })
          .catch(function () {}).finally(function () { if (group) group.style.pointerEvents = ''; syncAll(); });
        return;
      }

      var rec = e.target.closest('.jds-cart-recs__add-btn');
      if (rec) {
        var rvid = (rec.dataset.variantId || '').trim();
        if (!rvid) return;
        rec.disabled = true; rec.textContent = '...';
        addVariant(rvid).then(function () {
          rec.textContent = '✓ Added';
          rec.classList.add('jds-cart-recs__add-btn--added');
          return refreshCart();
        }).then(function () {
          setTimeout(function () {
            if (rec.isConnected) { rec.textContent = 'Add'; rec.classList.remove('jds-cart-recs__add-btn--added'); rec.disabled = false; }
          }, 2000);
        }).catch(function () { rec.textContent = 'Add'; rec.disabled = false; });
        return;
      }
    });

    document.addEventListener('cart:update', function (e) {
      var cart = e && e.detail && e.detail.resource;
      if (cart && cart.items) lastCart = cart;
      setTimeout(syncAll, 60);
      setTimeout(syncAll, 300);
      var src = e && e.detail && e.detail.data && e.detail.data.source;
      if (src && src !== 'jds-upsells') {
        spReconcile().then(function (changed) { if (changed) refreshCart(); else syncAll(); });
      }
    });

    try {
      var mo = new MutationObserver(scheduleResync);
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}

    /* on first load: read cart, sync visuals, then reconcile to stored prefs */
    getCart().then(function (cart) {
      syncAll();
      return Promise.all([spReconcile(cart), ftReconcile(ftPref(), cart)]);
    }).then(function (res) {
      if (res && (res[0] || res[1])) return refreshCart();
    }).then(function () { syncAll(); }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
